module.exports = {
  defaultLang: 'en',
  testnet: {
    contractAddress: 'cfxtest:acduca8bj4hbpe6df71046c4ns260kcd6yewbnfrdx',
    core: {
      name: "Conflux Testnet", 
      RPC: 'https://dev.goldshell-stake.dxpool.in/api/v1/networks/cfx/rpc?network_type=testnet&space=cspace',
      networkId: 1
    },
    explorer: 'https://testnet.confluxscan.io/address/'
  },
  mainnet: {
    contractAddress: 'cfx:acg0zctacp58wmsy39vpwxkn1f2ufxdbx69nev5ubk',
    core: {
      name: "Conflux Hydra", 
      RPC: 'https://dev.goldshell-stake.dxpool.in/api/v1/networks/cfx/rpc?network_type=mainnet&space=cspace',
      networkId: 1029
    },
    explorer: ''
  },
  baseUrl: 'https://dev.goldshell-stake.dxpool.in/api/v1',
  contactUrl: 'https://dev.goldshell-stake.dxpool.in/contact',
  helpUrl: 'https://dev.goldshell-stake.dxpool.in/help',
  espaceUrl: 'https://dev.goldshell-stake.dxpool.in/conflux',
  publicPath: '/'
}